import React from 'react';
import _ from 'underscore';

import * as ModalContainer from 'ui-library/ModalContainer';

import CreateComponentModal from './CreateComponentModal';

interface Props {
  initialFolderId: string;
  namePlaceholder?: string;
  onRequestClose: () => void;
  onConfirm: ({folderId, name}: {folderId: string; name: string}) => void;
  displaySelectionStart: number;
  displaySelectionEnd: number;
}

class CreatePartModal extends React.Component<Props> {
  static open(props: Props): void {
    // eslint-disable-next-line no-restricted-syntax
    const modalProps = _.extend({}, props, {
      // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
      onRequestClose: () => ModalContainer.close(CreatePartModal),
    });
    ModalContainer.open(CreatePartModal, <CreatePartModal {...modalProps} />);
  }

  render(): JSX.Element {
    const description =
      'A new part will be created and this region ' +
      `(${this.props.displaySelectionStart}-${this.props.displaySelectionEnd}) ` +
      'will be replaced with it.';
    return (
      <CreateComponentModal
        confirmButtonText="Replace"
        description={description}
        initialFolderId={this.props.initialFolderId}
        readableItemType="part"
        namePlaceholder={this.props.namePlaceholder}
        onConfirm={this.props.onConfirm}
        onRequestClose={this.props.onRequestClose}
        title="Replace selection with part"
      />
    );
  }
}

export default CreatePartModal;
